export default "__VITE_ASSET__CrSbn1fU__"